import Vue from 'vue'
import {Mutation, Action, VuexModule, getModule, Module} from "vuex-module-decorators";
import store from "@/store/store";
import {CmsApiClient} from "@/_global/api_clients/CmsApiClient";
import DeliousItemsStore from "@/_common/api/store/modules/DeliousItemsStore";
import {Util} from "@/_global/utils";
import CategoriesStore from "@/_common/api/store/modules/CategoriesStore";
import {DeliousApiUtil} from "@/_common/api/utils/delious_api_utils";
import CondimentGroupsStore from "@/_common/api/store/modules/CondimentGroupsStore";
import ItemsStore from "@/_common/api/store/modules/ItemsStore";


// カテゴリー別の販売商品一覧を格納する


@Module({
    name: "CategoryItemsStore",
    dynamic: true,
    store: store,
    namespaced: true
})
class CategoryItemsStore extends VuexModule {
    // state
    private _apiResponse: CMS.CategoryItem[] = [];
    private _categoryItemById: { [categoryItemId: number]: CMS.CategoryItem } = {};
    private _categoryItemsByCategoryId: { [categoryId: number]: CMS.CategoryItem[] } = {};

    // getter
    get all(): CMS.CategoryItem[] {
        return this._apiResponse || [];
    }

    get categoryItemById(): { [p: number]: CMS.CategoryItem } {
        return this._categoryItemById;
    }

    get categoryItemsByCategoryId(): { [p: number]: CMS.CategoryItem[] } {
        return this._categoryItemsByCategoryId;
    }

    @Action
    public async init(menuId: number) {
        const response: CMS.CategoryItem[] = (await CmsApiClient.getCategoryItems(menuId));
        const validResponse: CMS.CategoryItem[] = response.filter(v => DeliousItemsStore.itemById[v.item_id]);
        this.refresh(validResponse);
    }

    @Action
    private refresh(response: CMS.CategoryItem[]) {
        this.initVals();
        this.setResponse(response);
        for (let i = 0; i < response.length; i++) {
            this.setCategoryItemById(response[i]);
            this.setCategoryItemsByCategoryId(response[i]);
        }
    }

    @Mutation
    private initVals(): void {
        this._apiResponse = [];
        this._categoryItemById = {};
        this._categoryItemsByCategoryId = {};
    }

    @Mutation
    private setResponse(response: CMS.CategoryItem[]): void {
        this._apiResponse = response;
    }

    @Mutation
    private setCategoryItemById(categoryItem: CMS.CategoryItem): void {
        Vue.set(this._categoryItemById, categoryItem.id, categoryItem);
    }

    @Mutation
    private setCategoryItemsByCategoryId(categoryItem: CMS.CategoryItem): void {
        if (!this._categoryItemsByCategoryId[categoryItem.category_id])
            Vue.set(this._categoryItemsByCategoryId, categoryItem.category_id, []);

        this._categoryItemsByCategoryId[categoryItem.category_id].push(categoryItem);
    }

    @Action
    public async create(categoryItems: CMS.CategoryItem[]) {
        const added = this._apiResponse.concat(categoryItems);
        const categoryId = categoryItems[0].category_id;
        this.refresh(added);
        this.apply(categoryId);
    }

    @Action
    public async edit(categoryItem: CMS.CategoryItem) {
        const edited = this._apiResponse.map(v => (v.id == categoryItem.id) ? categoryItem : v);
        this.refresh(edited);
        this.apply(categoryItem.category_id);
    }

    @Action
    public async delete(categoryItemId: number) {
        const target = this.categoryItemById[categoryItemId];
        if (!target)
            return;

        const deleted = this._apiResponse.filter(v => v.id != categoryItemId);
        this.refresh(deleted);
        this.apply(target.category_id);
    }

    @Action
    public async localSort(sortedIds: number[]) {
        const excluded = this._apiResponse.filter(v => sortedIds.indexOf(v.id) < 0);
        const sorted = sortedIds.map(id => this._categoryItemById[id]);
        this.refresh(excluded.concat(sorted));
    }

    @Action
    public async applySort(categoryId: number) {
        this.apply(categoryId);
    }

    @Action
    private async apply(categoryId: number) {
        const menuId: number = CategoriesStore.categoryById[categoryId].menu_id;
        const categoryItems: CMS.CategoryItem[] = Util.deepCopy(this._categoryItemsByCategoryId[categoryId] || []);
        categoryItems.forEach((v, i) => v.sort_order = i);
        await CmsApiClient.setCategoryItems(menuId, categoryId, categoryItems);
        // this.init(menuId);
    }

    @Action
    public async addGroupItems(item_id: number) {
        // CMS用のオプショングループレコードがなければ作る
        const mainItemId = item_id;
        const item = DeliousItemsStore.itemById[mainItemId] as Delious.Item;
        const condimentGroups = DeliousApiUtil.itemToCondimentGroups(item);
        for (let i = 0; i < condimentGroups.length; i++) {
            const condimentGroupId: number = condimentGroups[i].condiment_group_no;
            if (!CondimentGroupsStore.condimentGroupById[condimentGroupId]) {
                const condimentGroup: CMS.CondimentGroup = {
                    condiment_group_id: condimentGroupId,
                    multi_select: false,
                    optional_select: false,
                    default_item_id: -1,
                    names: {}
                };
                await CondimentGroupsStore.create(condimentGroup);
            }
        }

        // CMS用の商品レコードがなければ作る
        const condimentItems: Delious.CondimentItem[] = DeliousApiUtil.condimentGroupsToCondimentItems(condimentGroups);
        const itemIds: number[] = [mainItemId].concat(condimentItems.map(v => v.plu_no));
        for (let i = 0; i < itemIds.length; i++) {
            const itemId: number = itemIds[i];
            // CMS商品を登録
            if (!ItemsStore.itemById[itemId]) {
                const cmsItem: CMS.Item = {
                    item_id: itemId,
                    image_url: "",
                    names: {}
                };
                await ItemsStore.create(cmsItem);
            }
        }
    }

}


export default getModule(CategoryItemsStore);
